<template>
  <div class="ProgressButton ProgressFillButton">
    <button
        :style="{ width: 'calc(' + percent + '% + 3%)' }"
        class="Button Button-danger"
        :class="{ 'display': percent > 0, 'label-active': percent >= 100  }"
        disabled
    ></button>

    <span @click.prevent="$emit('order')">Commander</span>
    
    <button
      class="Button not-filled"
      :class="{ disabled: isNotFull, 'Button-active': percent >= 100 }"
      :disabled="percent < 100"
      @click.prevent="$emit('order')"
      type="button">
      Commander
    </button>
  </div>
</template>
<script>
import "@/components/ProgressButton/ProgressButton.scss";
export default {
  name: "ProgressFillButton",
  data () {
    return {
      isNotFull: true,
    };
  },
  props: {
    percent: {
      type: Number,
      required: true,
      default: 0
    }
  },
  
  watch: {
    percent (newValue) {
      if (this.percent < 59) {
        this.isNotFull = true;
      } else {
        this.isNotFull = false;
      }
    },
  },
};
</script>